/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fac_Btn1Inputs */

const en_dr_room_fac_btn1 = /** @type {(inputs: Dr_Room_Fac_Btn1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarize`)
};

const id_dr_room_fac_btn1 = /** @type {(inputs: Dr_Room_Fac_Btn1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangkum`)
};

/**
* | output |
* | --- |
* | "Summarize" |
*
* @param {Dr_Room_Fac_Btn1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fac_btn1 = /** @type {((inputs?: Dr_Room_Fac_Btn1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fac_Btn1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fac_btn1(inputs)
	return en_dr_room_fac_btn1(inputs)
});